export * from 'server/models/DomainRelevance';


// WEBPACK FOOTER //
// ./data/models/DomainRelevance.ts